// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-20{margin-top:20px}.mb-20{margin-bottom:20px}.bold{font-weight:700}.paragraph-text{font-family:Nunito,sans-serif;text-align:justify;line-height:28px;font-size:20px;color:#444}", ""]);
// Exports
module.exports = exports;
